<mat-card>
    <mat-card-header>
        <mat-card-title>
            <prl-label value='label.profiles.create.new'/>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <mx-text-field
                [form]="form"
                [label]="'label.marketing.tools.profiles'"
                name="profileName"
                disabled="requestInProcess"
        ></mx-text-field>
    </mat-card-content>

    <mat-card-actions>
        <mx-button [buttonModel]="cancelButton"></mx-button>
        <mx-button [buttonModel]="addButton"></mx-button>
    </mat-card-actions>
</mat-card>
